import { Text } from "@overmap-ai/blocks"
import { type Document, UNTITLED_DOCUMENT_TITLE } from "@overmap-ai/common"
import { selectDocumentById } from "@overmap-ai/core"
import { Link } from "@tanstack/react-router"
import { type NodeViewProps, NodeViewWrapper } from "@tiptap/react"
import { memo } from "react"

import { DocumentIcon } from "../../../../components/Icons/DocumentIcon"
import { useAppSelector } from "../../../../store"

export const DocumentMentionComponent = memo((props: NodeViewProps) => {
	const { node } = props
	const { uuid } = node.attrs as { uuid: Document["uuid"] }

	const document = useAppSelector(selectDocumentById(uuid))

	return (
		<NodeViewWrapper
			className="bg-(--base-a3) py-0.25 inset-ring inset-ring-(--base-a6) rounded-md px-1 align-bottom"
			as="span"
		>
			{!!document &&
				(document.organization ? (
					<Link
						className="whitespace-nowrap"
						from="/$organizationId"
						to="/$organizationId/documents/$documentId"
						params={(prev) => ({ ...prev, documentId: document.uuid })}
					>
						<DocumentIcon documentId={document.uuid} background={false} className="align-sub" />
						<Text className="truncate">{document.title || UNTITLED_DOCUMENT_TITLE}</Text>
					</Link>
				) : (
					<Link
						className="whitespace-nowrap"
						from="/$organizationId/$projectId"
						to="/$organizationId/$projectId/documents/$documentId"
						params={(prev) => ({ ...prev, documentId: document.uuid })}
					>
						<DocumentIcon documentId={document.uuid} background={false} className="align-sub" />
						<Text className="truncate">{document.title || UNTITLED_DOCUMENT_TITLE}</Text>
					</Link>
				))}
		</NodeViewWrapper>
	)
})
DocumentMentionComponent.displayName = "DocumentMentionComponent"
